import {useContext, useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import { Box,Collapse, IconButton, LinearProgress,
    Paper, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Tooltip
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import axios from 'axios';
import qs from 'qs';
import moment from 'moment';
import {useHistory} from "react-router-dom";
import Rating from '@material-ui/lab/Rating';
import AddIcon from '@material-ui/icons/Add';
import NvoEditCuenta from './NvoEditCuenta';
 
import CreateIcon from '@material-ui/icons/Create';
import {AuthContext} from '../context/AuthContext'
import {celda} from '../Generales/TablaGeneral';
import {ErrorGeneral, llamaApiCargaToken} from '../funciones/ClienteAxios';
import {findNumber} from "../funciones/FindNumber";
const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 420,
    },
    tableRow: {
        "&$selected, &$selected:hover": {
            backgroundColor: process.env.REACT_APP_COLOR
        }
    },
    tableCell: {
        "$selected &": {
            color: "white"
        }
    },
    hover: {},
    selected: {}
});

export default function TablaCuenta({orden, }) {
    const classes = useStyles();
    const nvlSNPermiso = '5'
    const history = useHistory();
    const source = axios.CancelToken.source();
    const auxColor=process.env.REACT_APP_COLOR    
    const idusu= localStorage.getItem('UsuId');
    const [registro, setRegistro] = useState([]);
    const [datos, guardarDatos] = useState([])
    const [sinDatos, guardarSinDatos] = useState(false)
    const [ordenSelecc, setOrdenSelecc] = useState(0);
    const [open, setOpen] = useState(false);
    const [modalAbierto, setModalAbierto] = useState(false);
    const [selectActividad, setSelectActividad] = useState([])
    const [modalEditar, setModalEditar] = useState(false);
    const [actualizar, setActualizar] = useState(false);
    const {usuario} = useContext(AuthContext);
    const [espera, setEspera] = useState(false)

    useEffect(() => {
     


        setRegistro([])

        getList()
        return () => {
            source.cancel();
        }
    }, [orden,actualizar]);

    const getList = () => {
        const data = qs.stringify({
            Usuario: idusu,
            Proveedor:orden.Id,
            idDispositivo: '89y7gttvjhj98h'
        });
        const url = "/renta/proveedor/cuenta";

        function respuestaListAct(auxiliar) {
            if (auxiliar[0].Id !== -1 && auxiliar[0].Id !== "-1"&& auxiliar[0].Id !== 0) {
                guardarSinDatos(false)
                guardarDatos(auxiliar)
            } else {
                guardarSinDatos(true)
                guardarDatos([])
            }
        }

        llamaApiCargaToken(data, url, respuestaListAct, ErrorGeneral, setEspera, history, source);
    };

    const funcionActuliza=()=>{
        setActualizar(!actualizar)
    }

    const OrdenarFecha = (auxfecha) => {
        let modificada2 = moment.utc(auxfecha).local(true).format("DD/MM/YYYY HH:mm");
        return modificada2
    }

    function verMas(auxId) {
        if (auxId === ordenSelecc) {
            setOpen(!open)
        } else {
            setOpen(true)
        }
        setOrdenSelecc(auxId)
    }

    function nuevaActiv() {
        setModalAbierto(true)
    }

    function editarActiv(auxFalla) {        
        setModalEditar(true)
    }

    function tipoEstado(auxColor, idSelecc, auxEtiqueta) {
      /*   let auxEtiqueta = ''
        let auxColor = ''
        if (estado === 1) {
            auxEtiqueta = 'Registrado'
            auxColor = '#F46239'
        } else {
            if (estado === 3) {
                auxEtiqueta = 'Solucionado'
                auxColor = '#049b4f'
            } else {
                if (estado === 0) {
                    auxEtiqueta = 'Cancelado'
                    auxColor = 'red'
                }
            }
        } */
        let renglon = <div></div>
        registro?.Id === idSelecc ?
            renglon =
                <TableCell align="center" style={{color: 'white', fontWeight: 700, width: 100 + 'px'}} padding={'none'}>
                    {auxEtiqueta}
                </TableCell> :
            renglon = <TableCell align="center" style={{color: auxColor, fontWeight: 700, width: 100 + 'px'}}
                                 padding={'none'}>{auxEtiqueta}</TableCell>
        return renglon
    }
 
    function Row(props) {
        const {row} = props;
        let estiloFolio = {
            color: registro?.Id === row.Id ? 'white' : '#0AC15D',
            fontWeight: '980',
            fontSize: 18,
            width: 10 + 'px'
        }
        let radioPrioridad = <Rating name="rating-prioridad" value={row.prioridad} size="small" max={3} readOnly
                                     style={{color: registro?.Id === row.Id ? 'white' : auxColor}}/>
        return (
        <TableRow
            onClick={() => {
                setRegistro(row);
            }}
            selected={registro?.Id === row.Id}
            classes={{hover: classes.hover, selected: classes.selected}}
            className={classes.tableRow}
        >
        
            <TableCell align="center" padding={'none'} style={{width: 30 + 'px'}}>
                <Tooltip title={'Editar'}>
                    <IconButton aria-label="add circle" size="small" onClick={() => editarActiv(row)}
                        component="span">
                        {registro?.Id === row.Id ? <CreateIcon style={{color: 'white'}}/> :
                            <CreateIcon color="primary"/>}
                    </IconButton>
                </Tooltip>
            </TableCell> 
            {celda("center", {},<Tooltip title={row.BanNom}><img src={row.BanImg} width={"25px"} height={"25px"}  
                style={{borderRadius: "30%"}} /></Tooltip> , 2, classes.tableCell)}
            {celda("left", { fontSize:"12px", width: 125 + 'px', paddingLeft: 5 + 'px'}, row.Clabe , 3, classes.tableCell)}
            {celda("left", { width: 125 + 'px', paddingLeft: 5 + 'px' }, row.Alias , 3, classes.tableCell)}           
            { celda("left", {fontSize:"12px",}, row.Contacto, 2, classes.tableCell)}                    
        </TableRow>               
        );
    }

    const celdaVacia = <TableCell className={classes.tableCell} align="left" padding={'none'}></TableCell>
    const tablaCompleta = () => {

        return (
        <TableContainer className={classes.container}>
            <Table stickyHeader aria-label="sticky table">
                <TableHead>
                    <TableRow>
                        <TableCell align="left" padding={'none'}></TableCell>    
                        <TableCell align="left" padding={'none'}>Banco</TableCell>       
                        <TableCell align="center" padding={'none'}>Clabe</TableCell>
                        <TableCell align="center" padding={'none'}>Alias </TableCell>                                      
                                                
                        <TableCell align="left" padding={'none'}>Teléfono</TableCell>   
                    </TableRow>
                </TableHead>
                <TableBody>
                    {usuario?.nivel !== undefined && usuario.nivel !== nvlSNPermiso ?
                        <TableRow className={classes.tableRow}>
                            <TableCell className={classes.tableCell} align="left" padding={'none'}
                                style={{width: 30 + 'px'}}>
                            {findNumber('|2|') ? 
                                <Tooltip title={'Agregar Cuenta'}>
                                    <IconButton aria-label="agregar-Cuenta" size="small"
                                        onClick={() => nuevaActiv()} component="span">
                                        <AddIcon color="primary"/>
                                    </IconButton>
                                </Tooltip>
                            : null}
                            </TableCell>
                            <TableCell className={classes.tableCell} align="left" padding={'none'}
                                style={{fontWeight: 700, color: auxColor}}>
                                {findNumber('|2|') ?  'Nueva' : ""} 
                            </TableCell>
                            <TableCell className={classes.tableCell} align="center" padding={'none'} style={{
                                paddingLeft: 5 + 'px', fontWeight: 700, color: auxColor }}>{findNumber('|2|') ?  'Cuenta' : ""}</TableCell>
                            {celdaVacia}
                            {celdaVacia}
                            {celdaVacia}
                            {celdaVacia}
                            {celdaVacia}
                                
                        </TableRow>
                        : null
                    }
                    {datos.length !== 0 ? (datos.map((row) => (
                        <Row key={row.Id} row={row}/>
                    ))) : null}
                </TableBody>
            </Table>
        </TableContainer>
        )
    }
    const tablaSinDatos = () => {
        return (<TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" padding={'none'}>Folio </TableCell>
                            <TableCell align="center" padding={'none'}>Fecha</TableCell>
                    
                            <TableCell align="left" padding={'none'}>Tipo</TableCell>
                            <TableCell align="left" padding={'none'}>Descripción</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {usuario?.nivel !== undefined && usuario.nivel !== nvlSNPermiso ?
                            <TableRow className={classes.tableRow}>
                                <TableCell className={classes.tableCell} align="center" padding={'none'}
                                    style={{width: 40 + 'px', paddingLeft: 10 + 'px'}}>
                                    {findNumber('|2|') ? 
                                        <IconButton aria-label="agregar-Bitacora" size="small" 
                                            onClick={() => nuevaActiv()} component="span">
                                            <AddIcon color="primary"/>
                                        </IconButton>
                                     : null}
                                </TableCell>
                                <TableCell className={classes.tableCell} align="center" padding={'none'}
                                           style={{
                                               width: 120 + 'px',
                                               paddingLeft: 5 + 'px',
                                               fontWeight: 700,
                                               color: auxColor
                                           }}>
                                      {findNumber('|2|') ?  'Nueva' : ""}
                                </TableCell>
                                <TableCell className={classes.tableCell} align="center" padding={'none'}
                                           style={{
                                               width: 30 + 'px',
                                               paddingLeft: 5 + 'px',
                                               fontWeight: 700,
                                               color: auxColor
                                           }}>
                                    {findNumber('|2|') ?  'Cuenta' : ""}
                                </TableCell>
                                <TableCell className={classes.tableCell} align="left" padding={'none'}></TableCell>
                                <TableCell className={classes.tableCell} align="left" padding={'none'}></TableCell>
                            </TableRow>
                            : null
                        }
                        <TableRow className={classes.tableRow}>
                            <TableCell className={classes.tableCell} align="left" padding={'none'}
                                       style={{width: 30 + 'px'}}>
                            </TableCell>
                            <TableCell className={classes.tableCell} align="center" padding={'none'}
                                       style={{width: 120 + 'px', paddingLeft: 5 + 'px'}}>Registro </TableCell>
                            <TableCell className={classes.tableCell} align="center" padding={'none'}
                                       style={{width: 120 + 'px', paddingLeft: 5 + 'px'}}>Sin</TableCell>
                            <TableCell className={classes.tableCell} align="left"
                                       padding={'none'}>Cuentas</TableCell>
                            <TableCell className={classes.tableCell} align="left" padding={'none'}></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }
    const contenido = !sinDatos ? tablaCompleta() : tablaSinDatos()
    const cargando = !espera ? contenido : <Box my={2}><LinearProgress/></Box>
    const modal = modalAbierto ?        
                (<NvoEditCuenta titulo={'Nueva Cuenta'} modalAbierto={modalAbierto}
                    setModalAbierto={setModalAbierto} regis={[]}
                    funcionActuliza={funcionActuliza}  Proveedor={orden}
                />)
                : null                
   const modEdit = modalEditar ?        
                (<NvoEditCuenta titulo={'Editar Cuenta'} modalAbierto={modalEditar}
                    setModalAbierto={setModalEditar} regis={registro}
                    funcionActuliza={funcionActuliza}  Proveedor={orden}
                />)
                : null 
    return (
    <Paper className={classes.root}>
        {cargando}
        {  modal  }
        {modEdit}
    </Paper>
    );
}
